var ActionsRendererComponent = /** @class */ (function () {
    function ActionsRendererComponent() {
        this.actions = [];
    }
    ActionsRendererComponent.prototype.ngOnInit = function () {
    };
    ActionsRendererComponent.prototype.agInit = function (params) {
        this.params = params;
        this.data = params.data;
        this.actions = this.params.actions;
    };
    ActionsRendererComponent.prototype.refresh = function (params) {
        return true;
    };
    return ActionsRendererComponent;
}());
export { ActionsRendererComponent };
